import {List, ListItem} from '@mui/material';
import styled from 'styled-components';

const StyledList = styled(List)`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const StyledListItem = styled(ListItem)`
	width: 100%;
	padding: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: ${({theme}) => theme.colors.light.background.paper};
	border-radius: 8px;
`;

export {StyledList, StyledListItem};
